// extracted by mini-css-extract-plugin
export var clickableWrapper = "_38-2";
export var placeholderIcon = "_38-3";
export var thumbnailCanvas = "_38-1";
export var thumbnailWrapper = "_38-0";